const MaritalStatusDefiner = (val: any) => {
  let definedData = null
  switch (val) {
    case 'Single':
      definedData = { label: 'Lajang', value: 'Single' }
      break
    case 'Married':
      definedData = { label: 'Menikah', value: 'Married' }
      break
    case 'Divorced':
      definedData = { label: 'Cerai', value: 'Divorced' }
      break
    default:
      break
  }

  return definedData
}

export default MaritalStatusDefiner